<template>
    <ul class="pagination pagination-sm">
        <li class="page-item" :class="{disabled: isFirstPage}">
            <router-link class="page-link"
                         :to="getUrl(1)"
                         v-if="isModeHistory"
                         aria-label="Anterior">
                <span aria-hidden="true"><svg-icon icon="fast-backward"/></span>
            </router-link>
            <a v-else
               href="javascript:void(0)"
               @click="paginate(1)"
               class="page-link">
                <span aria-hidden="true"><svg-icon icon="fast-backward"/></span>
            </a>
        </li>
        <li class="page-item" :class="{disabled: isFirstPage}">
            <router-link class="page-link"
                         :to="getUrl(currentPage - 1)"
                         v-if="isModeHistory"
                         aria-label="Anterior">
                <span aria-hidden="true"><svg-icon icon="step-backward"/></span>
            </router-link>
            <a v-else
               href="javascript:void(0)"
               @click="paginate(currentPage - 1)"
               class="page-link">
                <span aria-hidden="true"><svg-icon icon="step-backward"/></span>
            </a>
        </li>
        <li v-for="page in createPagination()" :key="page.index" class="page-item" :class="{active: currentPage === page.label}">
            <router-link v-if="currentPage !== page.label && isModeHistory"
                         :to="getUrl(page.label)"
                         class="page-link">
                {{page.label}}
            </router-link>
            <span v-else-if="currentPage === page.label" class="page-link">{{page.label}}</span>
            <a v-else
               href="javascript:void(0)"
               @click="paginate(page.label)"
               class="page-link">
                {{page.label}}
            </a>
        </li>
        <li class="page-item" :class="{disabled: isLastPage}">
            <router-link class="page-link"
                         :to="getUrl(currentPage + 1)"
                         v-if="isModeHistory"
                         aria-label="Next">
                <span aria-hidden="true"><svg-icon icon="step-forward"/></span>
            </router-link>
            <a v-else
               href="javascript:void(0)"
               @click="paginate(currentPage + 1)"
               class="page-link">
                <span aria-hidden="true"><svg-icon icon="step-forward"/></span>
            </a>
        </li>
        <li class="page-item" :class="{disabled: isLastPage}">
            <router-link class="page-link"
                         :to="getUrl(total_pages)"
                         v-if="isModeHistory"
                         aria-label="Next">
                <span aria-hidden="true"><svg-icon icon="fast-forward"/></span>
            </router-link>
            <a v-else
               href="javascript:void(0)"
               @click="paginate(total_pages)"
               class="page-link">
                <span aria-hidden="true"><svg-icon icon="fast-forward"/></span>
            </a>
        </li>
        <li class="desc" v-if="total_pages && totalEntries">{{totalEntries | formatNumber(0, '.', '.')}} items em {{total_pages | formatNumber(0, '.', '.')}} página{{total_pages > 1 ? 's' : ''}}</li>
        <li class="desc" v-else>Não existem registros</li>
    </ul>
</template>

<script>
    export default {
        name: "Pagination",
        props: {
            current_page: {
                type: Number,
                default: 1,
                validator: v => v >= 0
            },
            page_size: {
                type: Number,
                default: 20,
                validator: v => v >= 0
            },
            max_pages: {
                type: Number,
                default: 5,
                validator: v => v > 0
            },
            total_entries: {
                type: Number,
                required: true,
                validator: v => v >= 0
            },
            mode: {
                type: String,
                default: 'history',
                validator: val => /(history|callback)/.test(val)
            }
        },
        data() {
            return {
                total_pages: 0
            }
        },
        methods: {
            createPagination() {
                const pages = [];
                let start = 0, end = this.max_pages;
                const pageCount = parseInt(this.total_entries / this.pageSize);
                const rest = this.total_entries % this.pageSize;
                this.total_pages = pageCount + (rest > 0 ? 1 : 0);

                if (this.current_page > 2) {
                    start = this.current_page - 2;

                    end = start + this.max_pages;

                    if (this.current_page >= (this.total_pages - 2)) {
                        start = this.total_pages - (this.total_pages < this.max_pages ? this.total_pages : this.max_pages);
                        end = this.total_pages;
                    }
                }

                if (this.total_pages < this.max_pages) end = this.total_pages;

                for (let i = start; i < end; i++)
                    pages.push({index: i, label: i + 1});

                return pages;
            },
            getUrl(page) {
                return {
                    query: {...this.$router.currentRoute.query, page: page}
                }
            },
            paginate(page) {
                this.$emit('paging', page);
            }
        },
        computed: {
            isFirstPage() {
                return this.current_page === 1 || this.total_pages === 0
            },
            isLastPage() {
                return this.total_pages === 0 || this.current_page === this.total_pages
            },
            isModeHistory() {
                return this.mode === 'history'
            },
            pageSize() {
                return this.page_size
            },
            currentPage() {
                return this.current_page
            },
            totalEntries() {
                return this.total_entries
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../assets/css/variables";
    .desc {
        vertical-align: middle;
        display: flex;
        align-items: flex-end;
        color: $theme_color_three;
        padding-left: 1em;
    }
</style>
